import $ from 'jquery';
import { onResize } from '../utils/window';

export default function headerSection() {
	const $html = $('html');
	const $scroller = $('html, body');

	// const $header = $('#header');
	// const $headerNav = $('#header-nav');
	// const headerToggler = $headerNav.data('toggler');

	// if (headerToggler) {

	// 	headerToggler.on('toggle', function() {
	// 		$html.toggleClass('is-header-open', headerToggler.isOpen);

	// 		if (headerToggler.isOpen) {
	// 			$scroller.animate({ scrollTop: 0 }, { duration: 200 });
	// 		}
	// 	});
	//  }
	
	const $hContent = $('#hero .home-slideshow .home-slideshow_slide .hero_content .hero_content_container');
	
	let height = 0;
	
	const setupHero = function () {
		$hContent.css('min-height', '');
		$hContent.each(function () {
			if($(this).outerHeight() > height) {
				height = $(this).outerHeight();
			}
		});

		$hContent.css('min-height', height+'px');

		height = 0;
	};

	if($hContent.length > 1) {
		setupHero();

		onResize(()=>{
			setupHero();
		});
	}
}



// WEBPACK FOOTER //
// ./source/scripts/sections/home.js